import { render } from "./ProductForm.vue?vue&type=template&id=028f2554"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__